module.exports = __webpack_public_path__ + "static/media/hw_wo_45.03b2aca7.flv";